import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const COLORS = ["#F59E0B", "#D97706", "#34D07F", "#4FA3FF", "#E9B824", "#C58BE0"];

function Confetti() {
  const pieces = Array.from({ length: 26 });
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {pieces.map((_, i) => {
        const x = (Math.random() - 0.5) * 340;
        const y = -(120 + Math.random() * 260);
        const r = `${Math.random() * 720 - 360}deg`;
        const delay = Math.random() * 0.15;
        return (
          <span
            key={i}
            className="confetti-piece"
            style={{
              left: "50%", top: "45%",
              background: COLORS[i % COLORS.length],
              // eslint-disable-next-line
              ["--x"]: `${x}px`, ["--y"]: `${y}px`, ["--r"]: r,
              animation: `confettiFall 1.1s ${delay}s cubic-bezier(.15,.6,.3,1) forwards`,
            }}
          />
        );
      })}
    </div>
  );
}

export default function SuccessCelebration({ show, title = "Listing Published!", subtitle, onDone }) {
  useEffect(() => {
    if (show) {
      try { navigator.vibrate?.([15, 40, 20]); } catch {}
      const t = setTimeout(() => onDone?.(), 2200);
      return () => clearTimeout(t);
    }
  }, [show, onDone]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[100] flex items-center justify-center"
          style={{ background: "rgba(0,0,0,0.55)", backdropFilter: "blur(6px)" }}
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          data-testid="success-celebration"
        >
          <Confetti />
          <motion.div
            initial={{ scale: 0.6, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 22 }}
            className="glass relative flex flex-col items-center rounded-3xl px-10 py-8 text-center"
            style={{ boxShadow: "var(--shadow)" }}
          >
            <motion.div
              className="mb-4 flex h-20 w-20 items-center justify-center rounded-full"
              style={{ background: "linear-gradient(135deg,#F59E0B,#D97706)" }}
              initial={{ scale: 0 }} animate={{ scale: 1 }}
              transition={{ type: "spring", stiffness: 260, damping: 14, delay: 0.1 }}
            >
              <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
                <motion.path
                  d="M12 23 L19 30 L33 15"
                  stroke="#fff" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round"
                  initial={{ pathLength: 0 }} animate={{ pathLength: 1 }}
                  transition={{ duration: 0.5, delay: 0.35, ease: "easeInOut" }}
                />
              </svg>
            </motion.div>
            <h3 className="font-display text-xl font-extrabold" style={{ color: "var(--text)" }}>{title}</h3>
            {subtitle && <p className="mt-1 max-w-[240px] text-sm text-dim">{subtitle}</p>}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
